const { gql } = require('@apollo/client');

export const CONNECT_SQUARE = gql`
  mutation ConnectSquare {
    connectSquare
  }
`;

export const DISCONNECT_SQUARE = gql`
  mutation DisconnectSquare {
    disconnectSquare
  }
`;
